const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/_user/profile/edit/engagement-report.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
export const Route = createFileRoute("/_authenticated/_feature_announcement/_user/profile/edit/engagement-report")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Engagement Report",
      description: "Page title for the user engagement report settings path"
    })
  }
});